import { render, staticRenderFns } from "./index_gaocheng_跳转.vue?vue&type=template&id=45248f0c&scoped=true&"
import script from "./index_gaocheng_跳转.vue?vue&type=script&lang=js&"
export * from "./index_gaocheng_跳转.vue?vue&type=script&lang=js&"
import style0 from "./index_gaocheng_跳转.vue?vue&type=style&index=0&id=45248f0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45248f0c",
  null
  
)

export default component.exports